export default __webpack_public_path__ + "static/media/bluecurve.1441a325.svg";